
import { useEffect, useState } from 'react';
import { getDocs, query as q, collection as col, QueryConstraint, getFirestore } from 'firebase/firestore';
import { getCollectionCount } from "../services/firestore";

export interface PropsUseCollection {
  path: string;
  queryConstraint: QueryConstraint[];
  extraPropsByItemArray?: Record<string, any>;
  whitPropsDateFormated?: boolean;
  formatDate?: string;
  wait?: boolean;
  initLoading?: boolean;
  withCount?: boolean;
}

const db = getFirestore();

const useCollection = <T extends {}>({ path, queryConstraint, extraPropsByItemArray, whitPropsDateFormated, formatDate, wait, initLoading = true, withCount }: PropsUseCollection) => {
  const [loading, setLoading] = useState<boolean>(initLoading);
  const [data, setData] = useState<Array<T>>([]);
  const [count, setCount] = useState<number>();
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    if (wait || !path) return;

    const init = async () => {
      try {
        setLoading(true);

        const _snapshot = await getDocs(q(col(db, path), ...queryConstraint));

        if (withCount) {
          const _count = await getCollectionCount(path, queryConstraint);

          setCount(_count);
        } else {
          setCount(undefined);
        }

        setData(
          _snapshot.docs.map(d => {
            let dataDoc = d.data();

            if (extraPropsByItemArray) {
              dataDoc = {
                ...dataDoc,
                ...extraPropsByItemArray
              };
            }

            return { ...dataDoc, id: d.id } as unknown as T;
          }) as Array<T>
        );
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, [queryConstraint, extraPropsByItemArray, whitPropsDateFormated, formatDate, path, wait, withCount]);

  return { loading, data, setData, error, count };
};

export default useCollection;